import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import {AuthenticationServiceProvider} from '../authentication-service/authentication-service';
import 'rxjs/add/operator/map';


@Injectable()
export class ServerProvider {
    BASE_URL = "https://finapp.englert.xyz/api";
    //BASE_URL = "http://127.0.0.1:8881/api";

    http_cli: Http;

    constructor(public http: Http, public auth_cli: AuthenticationServiceProvider) {
        this.http_cli = http;
    }

    getRequestOptions() : RequestOptions {
        let myHeaders = new Headers();
	    myHeaders.append('Authorization', "Basic " + this.auth_cli.authdata);
        let options = new RequestOptions({ headers: myHeaders, });

        return options;
    }

    getAccounts(user_id){
      return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/accounts', this.getRequestOptions());
    }

    getTransactions(user_id, account_id) {
      return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/transactions', this.getRequestOptions());
    }

    getCategories() {
      return this.http_cli.get(this.BASE_URL+"/categories", this.getRequestOptions());
    }
    createCategory(name){
      return this.http_cli.post(this.BASE_URL+"/categories", {"name": name}, this.getRequestOptions())
    }
    deleteCategory(id) {
        return this.http_cli.delete(this.BASE_URL+"/categories/"+id, this.getRequestOptions())
    }
    getPeriodicTransactions(user_id){
      return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/periodic_transactions', this.getRequestOptions())
    }
    getPeriodicTransaction(user_id, account_id, periodic_transaction_id){
        return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/periodic_transactions/'+periodic_transaction_id, this.getRequestOptions())
    }
    getPeriodicTransactionLog(user_id){
      return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/periodic_transaction_log', this.getRequestOptions())
  }
    editPeriodicTransaction(user_id, periodic_transaction){
        return this.http_cli.put(this.BASE_URL+'/users/'+user_id+'/accounts/'+periodic_transaction.account_id+'/periodic_transactions/'+periodic_transaction.id, periodic_transaction, this.getRequestOptions())
    }
    createPeriodicTransaction(user_id, account_id, data){
        return this.http_cli.post(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/periodic_transactions', data, this.getRequestOptions())
    }
    deletePeriodicTransaction(user_id, account_id, transaction_id){
        return this.http_cli.delete(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/periodic_transactions/'+transaction_id, this.getRequestOptions())
    }
    getTransaction(user_id, account_id, transaction_id){
      return this.http_cli.get(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/transactions/'+transaction_id, this.getRequestOptions())
    }
    updateTransaction(user_id, account_id, transaction_id, transaction){
      return this.http_cli.put(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/transactions/'+transaction_id, transaction, this.getRequestOptions())
    }
    createTransaction(user_id, account_id, transaction){
      return this.http_cli.post(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/transactions', transaction, this.getRequestOptions())
    }
    deleteTransaction(user_id, account_id, transaction_id){
      return this.http_cli.delete(this.BASE_URL+'/users/'+user_id+'/accounts/'+account_id+'/transactions/'+transaction_id, this.getRequestOptions())
    }
    createAccount(user_id, name){
      return this.http_cli.post(this.BASE_URL+'/users/'+user_id+'/accounts', {"name": name}, this.getRequestOptions())
    }
    editAccount(user_id, account_id, name){
      return this.http_cli.put(this.BASE_URL + '/users/'+user_id+'/accounts/'+account_id, {"name":name}, this.getRequestOptions())
    }
    auth(username:String, password:String) {
      return this.http_cli.post(this.BASE_URL + '/auth', { username: username, password: password }, this.getRequestOptions())
    }
    deleteAccount(user_id, account_id) {
      return this.http_cli.delete(this.BASE_URL + '/users/'+user_id+'/accounts/'+account_id, this.getRequestOptions())
    }
    getTransactionReport(start_date, stop_date){
        return this.http_cli.get(this.BASE_URL + '/reports/monthly?start='+start_date.toISOString().substring(0, 10)+'&stop='+stop_date.toISOString().substring(0, 10), this.getRequestOptions())
    }
    getDetailedMonthlyReport(start_date, stop_date) {
        return this.http_cli.get(this.BASE_URL + '/reports/monthly/detailed?start='+start_date.toISOString()+'&stop='+stop_date.toISOString(), this.getRequestOptions())
    }
    getMonthlyOverviewReport(start_date : Date, stop_date : Date) {
        return this.http_cli.get(this.BASE_URL + '/reports/monthly/overview?start='+start_date.toISOString()+'&stop='+stop_date.toISOString(), this.getRequestOptions())
    }
}



// WEBPACK FOOTER //
// ./src/providers/server/server.ts